import React from "react";
import {
    Box,
    TextField,
    InputAdornment,
    IconButton,
    Container,
    Stack,
    Button,
    FormControl,
    Divider,
} from "@mui/material";
import Search from "@mui/icons-material/Search";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import RemoveCircle from "@mui/icons-material/RemoveCircle";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import ManageSearch from "@mui/icons-material/ManageSearch";
import { object, string, number, boolean, date, coerce, TypeOf, array } from 'zod';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import * as crudgen from "../../../../share";
import {formatDateTime, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import {useDebounce} from "react-use";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useDispatch} from "react-redux";
import useSearch from "../../../../hooks/useSearch";
import { Trans } from "@lingui/react/macro";
import { t, msg } from "@lingui/core/macro";





type IProps = {
    prefix?: string;
    setSearchInputValue: (search: string) => void;
    
    query: any;
    refetch: () => void;
}

const AccountingUserListSearch = (props: IProps) => {
    
    const {advancedSearch, search, updateSearch} = useSearch('AccountingUser')
    
    

    React.useEffect(() => {
        if (!advancedSearch) {
            props.setSearchInputValue(search)
        }
    }, []);
    return (<Box
        component="form"
        onSubmit={(e) => {e?.preventDefault()}}
        noValidate
        sx={ { '& > :not(style)': { m: 1, width: '100%', padding: '1em' } } }
        autoComplete="off"
        data-testid="AccountingUser-search-form"
    >
        <TextField
            defaultValue={ !advancedSearch ? search : '' }
            label={t`Search (by Email, Name)`}
            onChange={ (event) => {
                props.setSearchInputValue(event.target.value)
                updateSearch(false, event.target.value)
            } }
            variant="standard"
            slotProps={ {
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => {
                                    props.setSearchInputValue('')
                                    updateSearch(false, '')
                                } }
                                edge="end"
                            >
                                <Clear />
                            </IconButton>
                            <IconButton
                                onClick={props.refetch}
                                edge="end"
                            >
                                <Refresh />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            } }
        />
    </Box>)
    
}

export default AccountingUserListSearch;
